import { useState, useEffect } from "react";
import API from "@/lib/api";

const ACTION_COLORS = {
  employee_login: "bg-purple-50 text-purple-700", logout: "bg-slate-700 text-slate-600 dark:text-slate-300",
  order_approved: "bg-emerald-50 text-emerald-700", order_denied: "bg-red-50 text-red-700",
  document_upload: "bg-amber-50 text-amber-700", view_patient_record: "bg-blue-50 text-blue-700",
};

export default function PrescriberActivityTab() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get("/audit-logs?limit=100").then(({ data }) => setLogs(data.logs)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="text-center py-12 text-slate-400 dark:text-slate-500">Loading activity...</div>;

  return (
    <div data-testid="prescriber-activity-tab">
      <h1 className="text-2xl font-bold text-slate-800 dark:text-slate-100 mb-6" style={{ fontFamily: "'Outfit', sans-serif" }}>My Activity Log</h1>
      <div className="bg-slate-100 dark:bg-slate-800 rounded-xl border border-slate-300 dark:border-slate-700 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-white dark:bg-slate-900 border-b border-slate-300 dark:border-slate-700">
            <tr>
              <th className="text-left px-4 py-3 text-slate-400 dark:text-slate-500 font-medium">Time</th>
              <th className="text-left px-4 py-3 text-slate-400 dark:text-slate-500 font-medium">Action</th>
              <th className="text-left px-4 py-3 text-slate-400 dark:text-slate-500 font-medium">Details</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-200 dark:divide-slate-800">
            {logs.map((log) => (
              <tr key={log.id} className="hover:bg-slate-800/50">
                <td className="px-4 py-2 text-xs text-slate-500 dark:text-slate-400 whitespace-nowrap">{new Date(log.timestamp).toLocaleString()}</td>
                <td className="px-4 py-2">
                  <span className={`text-xs font-medium px-2 py-1 rounded-full ${ACTION_COLORS[log.action] || "bg-slate-700 text-slate-600 dark:text-slate-300"}`}>
                    {log.action.replace(/_/g, " ")}
                  </span>
                </td>
                <td className="px-4 py-2 text-xs text-slate-600 dark:text-slate-300 max-w-[400px] truncate">{log.details}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && <div className="p-8 text-center text-slate-400 dark:text-slate-500">No activity yet</div>}
      </div>
    </div>
  );
}
